import React from 'react'
import { View } from 'styles/reactnative'
import { Upload } from 'antd'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import { beforeUpload } from 'utils/ExpensiveFunction'
import { useWindowDimensions } from 'app/hooks'

const EventCreateImage = ({ images, setImages }) => {
	const { width } = useWindowDimensions()
	const onChange: UploadProps['onChange'] = (file: any) => {
		setImages(file?.fileList)
	}

	const onPreview = async (file: UploadFile) => {
		let src = file.url as string
		if (!src) {
			src = await new Promise(resolve => {
				const reader = new FileReader()
				reader.readAsDataURL(file.originFileObj as RcFile)
				reader.onload = () => resolve(reader.result as string)
			})
		}
		const image = new Image()
		image.src = src
		const imgWindow = window.open(src)
		imgWindow?.document.write(image.outerHTML)
	}

	return (
		<View
			style={{
				width: '100%',
				padding: 3,
				marginTop: width < 600 ? 150 : 30,
				marginBottom: 30,
			}}>
			<Upload
				name="avatar"
				listType="picture-card"
				className="avatar-uploader"
				fileList={images}
				onChange={onChange}
				beforeUpload={beforeUpload}
				style={{
					borderColor: 'blue',
				}}
				onPreview={onPreview}
				multiple={true}>
				{images.length < 4 && '+ Upload'}
			</Upload>
		</View>
	)
}

export default EventCreateImage
